export default {
  default: () => import("/vercel/path1/layouts/default.vue")
}